<template>
  <div style="height: inherit">
    <section id="ecommerce-header">
      <div class="row">
        <div class="col-sm-12">
          <div class="ecommerce-header-items">{{ title.label }}</div>
        </div>
      </div>
    </section>
    <div class="body-content-overlay" />
    <div class="ecommerce-searchbar mt-1">
      <b-row>
        <b-col md="4" cols="12">
          <b-form class="d-flex align-items-center" @submit.prevent="onSearch">
            <b-form-input v-model="search" />
            <b-button variant="primary" class="ml-1" type="submit">
              جستجو
            </b-button>
          </b-form>
        </b-col>
      </b-row>
    </div>
    <section class="d-flex flex-wrap py-1" v-if="loading">
      <div class="col-md-3 col-sm-6 col-12" v-for="i in 4" :key="i">
        <b-card class="ecommerce-card" no-body>
          <div class="card-img-top">
            <b-skeleton height="150px" width="100%" />
          </div>
          <b-skeleton height="80px" class="mb-2 mt-1" width="100%" />
          <b-skeleton height="30px" width="100%" class="mb-0" />
        </b-card>
      </div>
    </section>
    <section class="d-flex flex-wrap py-1" v-else-if="items.length">
      <div
        class="col-lg-3 col-md-4 col-sm-6 col-12 p-sm-1 p-0 my-1"
        v-for="(item, index) in items"
        :key="index"
      >
        <card :item="item" :title="title" />
      </div>
      <loader :loading="loader" />
    </section>
    <section v-else class="pt-2">
      <b-badge
        variant="light-secondary"
        class="mb-75 w-100 font-weight-bolder p-75"
      >
        <h6 class="text-secondary mb-0">موردی یافت نشد</h6>
      </b-badge>
    </section>

    <section>
      <b-row>
        <b-col cols="12">
          <b-pagination
            v-if="Object.keys(pagination).length"
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="pagination.per_page"
            size="md"
            class="my-2 d-flex justify-content-center"
          ></b-pagination>
        </b-col>
      </b-row>
    </section>
  </div>
</template>
<script>
import {
  BDropdown,
  BDropdownItem,
  BFormRadioGroup,
  BFormRadio,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BCard,
  BCardBody,
  BLink,
  BImg,
  BCardText,
  BButton,
  BPagination,
  BSkeleton,
  BBadge,
  BForm,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@core/components/loader/Loader.vue";
import Card from "./Card.vue";
export default {
  components: {
    // BSV
    BDropdown,
    BDropdownItem,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BCard,
    BCardBody,
    BLink,
    BImg,
    BCardText,
    BButton,
    BPagination,
    BSkeleton,
    BBadge,
    BForm,
    Loader,
    Card,
  },
  data() {
    return {
      search: "",
      currentPage: 1,

      loader: false,
    };
  },

  props: {
    title: {
      type: Object,
      default: () => {},
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  watch: {
    currentPage(val) {
      this.$emit("changedPagination", { page: val, api: this.title.value });
    },
    search(val) {
      if (!val) {
        this.$emit("changedSearch", { key: val, api: this.title.value });
      }
    },
  },
  methods: {
    async checkout(item) {
      if (Object.keys(this.userData).length) {
        this.loader = true;
        try {
          const { data } = await this.$http.post("/panel/invoices", {
            items: [
              {
                model: {
                  id: item.id,
                  type: this.title.value,
                },
              },
            ],
          });
          this.loader = false;

          this.$router.push({
            name: "checkout",
            query: {
              invoice_id: data.data.id,
            },
          });
        } catch (err) {
          this.loader = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: `مشکلی پیش آمده است.`,
                icon: "InfoIcon",
                variant: "danger",
              },
            },
            { position: "bottom-right" }
          );
        }
      } else {
        localStorage.setItem("invoice", item.id);
        this.$router.push("/login");
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              duration: 100000,
              title: `لطفا برای خرید دوره وارد حساب کاربری خود شوید`,
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async onSearch() {
      if (this.search) {
        this.$emit("changedSearch", {
          key: this.search,
          api: this.title.value,
        });
      }
    },
   
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
</style>
